var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    _vm._l(_vm.items, function (item) {
      return _c(
        "li",
        {
          key: item.userCode,
          staticClass:
            "d-table w-100-p h-67 b-b b-c-g-100 cursor-default bg-g-50-hover",
          on: {
            click: function ($event) {
              return _vm.itemClickEvent(item)
            },
          },
        },
        [
          _c("div", { staticClass: "d-table-cell v-a-middle h-100-p w-64" }, [
            _c(
              "span",
              {
                staticClass:
                  "d-block m-auto w-40 h-40 l-h-40 t-a-center c-white rounded user-select-none",
                staticStyle: { "background-color": "#704BFE" },
              },
              [_vm._v(_vm._s(_vm.getShortNickname(item.userName)))]
            ),
          ]),
          _c("div", { staticClass: "d-table-cell v-a-middle h-100-p" }, [
            _c("div", { style: { width: _vm.listWidth + "px" } }, [
              _c("p", { staticClass: "t-ellipsis l-h-1-6-em" }, [
                _vm._v(_vm._s(item.userName)),
                _c("span", { staticClass: "f-s-12" }, [
                  _vm._v(
                    " " + _vm._s(item.userCode) + _vm._s(_vm.getUserRole(item))
                  ),
                ]),
              ]),
              _c("p", { staticClass: "t-ellipsis l-h-1-6-em f-s-12 c-g-500" }, [
                _vm._v(
                  _vm._s(item.stationName) + " " + _vm._s(item.stationCode)
                ),
              ]),
            ]),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }